<template>
  <div class="grid-x">
    <div class="cell small-12 large-2">
      <v-base-panel
        v-if="!$methods.isMobile()"
        title="Menu Principal"
        :mainLink="{name: 'home'}"
        :menuPrincipal="menuPrincipal"
        :secondaryLink="{name: 'home'}"
        secondaryTitle="Ayuda-Soporte"
        :secondaryOptions="secondaryOptionsPanel"
      />
    </div>
    <div class="cell small-12 large-10">
      <router-view ></router-view>
    </div>
  </div>

  <div v-if="dataHome">
    <a v-if="dataHome.shownotify" :href="dataHome.link_notify" class="home-flotaing" target="_blank">
      <icono
        class="home-flotaing__icon" 
        icon="mdiBellRing" 
        :size="20"
        :style="{color: '#ffffff',}"></icono>
    </a>
  </div>
  <!-- menu en dispotivos moviles -->
  <v-menu-mov :options="menuPrincipal"/>
</template>

<script>

  import { mapGetters } from 'vuex'
  //
  import HeaderMainUser from '@/components/includes/HeaderMainUser.vue'
  // components
  import VMenuMov from '@/components/base/VMenuMov.vue'
  import VBasePanel from '@/components/base/VBasePanel.vue'
  

  export default {
    name: 'PanelNavigation',
    components: {
      HeaderMainUser,
      VMenuMov,
      VBasePanel,
    },
    computed: {
      ...mapGetters({
        dataUser: 'dataUser',
        isLoggedIn: 'isLoggedIn',
        dataHome: 'dataHome',
      })
    },
    data() {
      return {
        menuPrincipal: [
          {'id': 5, 'option': 'Inicio', 
            'icon': 'mdiHomeCircleOutline', 
            'color': '#424242', 
            'link': {'name': 'home-user',}},
          {'id': 0, 'option': 'Torneos', 
            'icon': 'mdiTrophyOutline', 
            'color': '#424242', 
            'link': {'name': 'torneos-user',}},
          {'id': 1, 'option': 'Tienda', 
            'icon': 'mdiStore', 
            'color': '#424242', 
            'link': {'name': 'tienda',}},
          {'id': 2, 'option': 'Equipos', 
            'icon': 'mdiShieldOutline', 
            'color': '#424242', 
            'link': {'name': 'equipos-user',}},
          {'id': 3, 'option': 'Herramientas', 
            'icon': 'mdiTools', 
            'color': '#424242', 
            'link': {'name': 'panel-tools',}},
          {'id': 4, 'option': 'Noticias', 
            'icon': 'mdiNewspaper', 
            'color': '#424242', 
            'link': {'name': 'news-user',}},
        ],
        secondaryOptionsPanel: [
          {'id':1, 'option': 'Novedades', 'icon': 'mdiNewspaperVariantOutline', 'link': 'https://youtube.com/playlist?list=PLFPLs277S8P5_e_R3cEYYOZVuT-_58TgD', 'ruta': false},
          {'id':2, 'option': 'Sugerencias', 'icon': 'mdiBookEditOutline', 'link': 'https://www.facebook.com/dstorneos/', 'ruta': false},
          {'id':3, 'option': 'Soporte DS', 'icon': 'mdiLaptop', 'link': 'https://docs.google.com/forms/d/e/1FAIpQLSePR3_oSLDXC_ndnxvTH-eyw62kc5aPfJOQwR7zPzcjT7Mhog/viewform?usp=sf_link', 'ruta': false},
          {'id':4, 'option': 'Tutoriales/Guias', 'icon': 'mdiYoutube', 'link': 'https://www.youtube.com/channel/UCXLqL61psWQGGspwXo_7sFQ', 'ruta': false},
        ]
      }
    },
  }
</script>

<style lang="scss" scoped>
.home-flotaing {
    position: absolute;
    bottom: 60px;
    right: 10px;
    background: #e74c3c;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    animation-name:glow;
    animation-duration:1s;
    animation-iteration-count:infinite;
    animation-direction:alternate;
    @include desde($large) {
      right: 30px;
      bottom: 40px;
    }
    &__icon {
      margin-bottom: -3px;
    }
  }
  @keyframes glow{
    from{
      background: #ff5252;
    }
    to{background: #b33939;}
  }
</style>